// extracted by mini-css-extract-plugin
export default {"root":"nZNNCAGhfjy6TSPWERs9","title":"O4_IvbFjrxgV7JBX1ucn","description":"RkseETDyRTUnjORwS2wg","placeHolderShimmer":"mskelmQ6OY5LtUAa7ML2"};